import PropTypes from 'prop-types';
import React, { Fragment } from 'react';

import CloneButton from '@/features/campaignsPage/Page/Row/buttons/CloneButton';
import EditButton from '@/features/campaignsPage/Page/Row/buttons/EditButton';

const ModeratingStatusActions = ({ itemId }) => (
  <Fragment>
    <CloneButton itemId={itemId} small={false} color="primary" />
    <EditButton
      itemId={itemId}
      small={false}
      color="primary"
      variant="contained"
    />
  </Fragment>
);

ModeratingStatusActions.propTypes = {
  itemId: PropTypes.number.isRequired,
};

export default ModeratingStatusActions;
